import { Component } from '@angular/core';
import { NewPaymentComponent } from '../../../pages/services/features/new-payment/new-payment.component';
import { WifiQRCodeComponent } from '../../../pages/services/ui/wifi-qrcode/wifi-qrcode.component';
import { PaymentQRCodeComponent } from '../../../pages/services/ui/payment-qrcode/payment-qrcode.component';
import { RequestPaymentComponent } from '../../../pages/services/features/request-payment/request-payment.component';

@Component({
  selector: 'qwiko-all-services',
  imports: [
    NewPaymentComponent,
    WifiQRCodeComponent,
    PaymentQRCodeComponent,
    RequestPaymentComponent,
  ],
  templateUrl: './all-services.component.html',
  styleUrl: './all-services.component.scss',
})
export class AllServicesComponent {}
